export default {
  api: '',
  appName: ''
}



// WEBPACK FOOTER //
// ./src/store/settings/state.js